import { z } from 'zod';

export const logEntrySchema = z.object({
  id: z.number(),
  content: z.string(),
  severity: z.string(),
  type: z.string(),
  objectIdentifier: z.string().nullable(),
  objectClass: z.string().nullable(),
  mapName: z.string().nullable(),
  source: z.string().nullable(),
});
